"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UUID = void 0;
var uuid_1 = require("uuid");
var isUUID_1 = __importDefault(require("validator/lib/isUUID"));
var InvalidUUIDException_1 = require("../exceptions/InvalidUUIDException");
var UUID = /** @class */ (function () {
    function UUID(value) {
        this.value = value;
        if (!UUID.validate(value)) {
            throw new InvalidUUIDException_1.InvalidUUIDException({ raw: value });
        }
    }
    UUID.generate = function () {
        var id = (0, uuid_1.v4)();
        return new UUID(id);
    };
    UUID.validate = function (id) {
        try {
            return (0, isUUID_1.default)(id, 4);
        }
        catch (error) {
            return false;
        }
    };
    UUID.prototype.matches = function (uuid) {
        return this.value === uuid.value;
    };
    return UUID;
}());
exports.UUID = UUID;
